// extracted by mini-css-extract-plugin
export var hero = "heroMedia-module--hero--7v-ss";
export var heroLayer = "heroMedia-module--heroLayer--yJTcN";
export var leftDots = "heroMedia-module--leftDots--VDigb";
export var rightDots = "heroMedia-module--rightDots--Omlwi";
export var heroGeneralText = "heroMedia-module--heroGeneralText--1YQ4V";